import React, {ReactElement} from 'react'
import {FlexContainer, FlexStaticContent} from '../styledComponents/FlexComponents'
import {ContentsAreaComponent} from '../styledComponents/ContentsArea'
import {StyledDiv} from '../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {BreakPoint, BreakpointValues, Colors, DispWidthSize} from '../styledComponents/Constants'
import {GlobalStyleGuest} from '../styledComponents/GlobalStyleGuest'
import HolidaysRepository from '../components/HolidaysRepository'
import NatCurrentDateTimeRepo from '../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'

import {generateMedia} from 'styled-media-query'
import {SessionStorageHelper} from '../SessionStorageHelper'
import EventEmitterExGuest from '../components/shared/pageBaseComponents/EventEmitterExGuest'

import equal from 'fast-deep-equal'
import {createTheme, StyledEngineProvider, ThemeProvider} from '@mui/material'
import {Location, matchPath, PathPattern, Route, Routes} from 'react-router-dom'
import {SubRoutesGuest} from '../__NoAutomatedTests/SubRoutesGuest'
import {RoutesGuest} from './RoutesGuest'
import NatSessionRepo from '../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import NatGuestHeaderAreaComponent from '../__NoAutomatedTests/components/header/NatGuestHeaderAreaComponent'
import NatGuestFooterAreaComponent from '../__NoAutomatedTests/components/footer/NatGuestFooterAreaComponent'
import {
    NatOwnershipTransfersRepo,
} from '../__NoAutomatedTests/components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import NatCondominiumRepo from '../__NoAutomatedTests/components/condominium/repository/NatCondominiumRepo'
import NatGuestLoginRepo from '../__NoAutomatedTests/components/login/repository/NatGuestLoginRepo'
import {
    GuestLoginInfoSessionStorageKey,
} from '../__NoAutomatedTests/common/authentication/NatGuestLoginInfoSessionStorageHelper'
import {AppGuestContext} from './AppGuestContext'
import {NatTwoFactorAuthRepo} from '../__NoAutomatedTests/components/twoFactorAuth/repository/NatTwoFactorAuthRepo'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'


// TODO: @mui/styles用 styled-componentsを使用するため削除してDefaultThemeはstyled-componentsの物を使用する
// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }


const EVENT_EMITTER_SET_MAX_LISTENERS: number = 1000

interface Props {
    natSessionRepo: NatSessionRepo
    condominiumsRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    natCurrentDateTimeRepo: NatCurrentDateTimeRepo
    guestLoginRepo: NatGuestLoginRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    twoFactorAuthRepo: NatTwoFactorAuthRepo
}

interface State {
    loginedFlg: boolean
}

const theme = createTheme({
    typography: {
        fontFamily: '"Noto Sans JP","游ゴシック Medium",YuGothic,YuGothicM,"Hiragino Kaku Gothic ProN",\
                     "Hiragino Kaku Gothic Pro",メイリオ,Meiryo,sans-serif',
    },
    palette: {
        primary: {
            main: Colors.GuestPrimary,
        },
    },
    breakpoints: {
        values: BreakpointValues,
    },
})

export default class AppGuest extends React.Component<Props, State> {
    private eventEmitter: EventEmitterExGuest

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            loginedFlg: (SessionStorageHelper.getStringItemOrNull(
                GuestLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID,
            ) !== null),
        }

        this.eventEmitter = new EventEmitterExGuest()
        this.eventEmitter.setMaxListeners(EVENT_EMITTER_SET_MAX_LISTENERS)
    }

    componentDidUpdate(prevProps: Props, prevState: State): void {
        if (!equal(prevState.loginedFlg,
            (SessionStorageHelper.getStringItemOrNull(
                GuestLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID,
            ) !== null),
        )) {
            this.setState({
                loginedFlg: (SessionStorageHelper.getStringItemOrNull(
                    GuestLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID,
                ) !== null),
            })
        }
    }

    updateLoginedFlg = (loginedFlg: boolean): void => {
        this.setState({loginedFlg: loginedFlg})
    }

    render(): ReactElement {
        return (
            <AppGuestContext.Provider
                value={{
                    loginedFlg: this.state.loginedFlg,
                    updateLoginedFlg: this.updateLoginedFlg,
                }}
            >
                <GlobalStyleGuest/>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <GuestRootFlexContainer>
                            <GuestHeaderFlexContainer>
                                <Routes>
                                    <Route
                                        path="/guest/error"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatGuestHeaderAreaComponent
                                                navigate={props.navigate}
                                                location={props.location}
                                                ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                eventEmitter={this.eventEmitter}
                                                sessionRepo={this.props.natSessionRepo}
                                                loginedFlg={false}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                    <Route
                                        path="/guest/contactus"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatGuestHeaderAreaComponent
                                                navigate={props.navigate}
                                                location={props.location}
                                                ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                eventEmitter={this.eventEmitter}
                                                sessionRepo={this.props.natSessionRepo}
                                                loginedFlg={false}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                    <Route
                                        path="/guest/contents/policy"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatGuestHeaderAreaComponent
                                                navigate={props.navigate}
                                                location={props.location}
                                                ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                eventEmitter={this.eventEmitter}
                                                sessionRepo={this.props.natSessionRepo}
                                                loginedFlg={false}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                    <Route
                                        path="/guest/externalTransmission"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatGuestHeaderAreaComponent
                                                navigate={props.navigate}
                                                location={props.location}
                                                ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                eventEmitter={this.eventEmitter}
                                                sessionRepo={this.props.natSessionRepo}
                                                loginedFlg={false}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                    <Route
                                        path="/*"
                                        element={<RouterPropsInjector>{(props) =>
                                            <NatGuestHeaderAreaComponent
                                                navigate={props.navigate}
                                                location={props.location}
                                                ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                eventEmitter={this.eventEmitter}
                                                sessionRepo={this.props.natSessionRepo}
                                                loginedFlg={this.state.loginedFlg}
                                            />
                                        }</RouterPropsInjector>}
                                    />
                                </Routes>
                            </GuestHeaderFlexContainer>
                            <GuestContentsAreaContainer>
                                <GuestContentsAreaComponent>
                                    <Routes>
                                        {RoutesGuest({})}
                                        {SubRoutesGuest({
                                            eventEmitter: this.eventEmitter,
                                            condominiumRepo: this.props.condominiumsRepo,
                                            currentDateTimeRepo: this.props.natCurrentDateTimeRepo,
                                            ownershipTransfersRepo: this.props.ownershipTransfersRepo,
                                            holidaysRepo: this.props.holidaysRepo,
                                            guestLoginRepo: this.props.guestLoginRepo,
                                            sessionRepo: this.props.natSessionRepo,
                                            twoFactorAuthRepo: this.props.twoFactorAuthRepo,
                                        })}
                                    </Routes>
                                </GuestContentsAreaComponent>
                            </GuestContentsAreaContainer>
                            <Routes>
                                <Route
                                    path="/guest/error"
                                    element={<RouterPropsInjector>{(props) =>
                                        <footer>
                                            <GuestFooterFlexStaticContent>
                                                <NatGuestFooterAreaComponent
                                                    navigate={props.navigate}
                                                    ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                    eventEmitter={this.eventEmitter}
                                                    loginedFlg={false}
                                                    location={props.location}
                                                />
                                            </GuestFooterFlexStaticContent>
                                        </footer>
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/guest/contactus"
                                    element={<RouterPropsInjector>{(props) =>
                                        <footer>
                                            <GuestFooterFlexStaticContent>
                                                <NatGuestFooterAreaComponent
                                                    navigate={props.navigate}
                                                    ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                    eventEmitter={this.eventEmitter}
                                                    loginedFlg={false}
                                                    location={props.location}
                                                />
                                            </GuestFooterFlexStaticContent>
                                        </footer>
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/guest/contents/policy"
                                    element={<RouterPropsInjector>{(props) =>
                                        <footer>
                                            <GuestFooterFlexStaticContent>
                                                <NatGuestFooterAreaComponent
                                                    navigate={props.navigate}
                                                    ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                    eventEmitter={this.eventEmitter}
                                                    loginedFlg={false}
                                                    location={props.location}
                                                />
                                            </GuestFooterFlexStaticContent>
                                        </footer>
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/guest/externalTransmission"
                                    element={<RouterPropsInjector>{(props) =>
                                        <footer>
                                            <GuestFooterFlexStaticContent>
                                                <NatGuestFooterAreaComponent
                                                    navigate={props.navigate}
                                                    ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                    eventEmitter={this.eventEmitter}
                                                    loginedFlg={false}
                                                    location={props.location}
                                                />
                                            </GuestFooterFlexStaticContent>
                                        </footer>
                                    }</RouterPropsInjector>}
                                />
                                <Route
                                    path="/*"
                                    element={<RouterPropsInjector>{(props) =>
                                        <footer>
                                            <GuestFooterFlexStaticContent>
                                                <NatGuestFooterAreaComponent
                                                    navigate={props.navigate}
                                                    ownershipTransfersRepo={this.props.ownershipTransfersRepo}
                                                    eventEmitter={this.eventEmitter}
                                                    loginedFlg={this.state.loginedFlg}
                                                    location={props.location}
                                                />
                                            </GuestFooterFlexStaticContent>
                                        </footer>
                                    }</RouterPropsInjector>}
                                />
                            </Routes>
                        </GuestRootFlexContainer>
                    </ThemeProvider>
                </StyledEngineProvider>
            </AppGuestContext.Provider>
        )
    }
}

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const GuestRootFlexContainer = styled(FlexContainer)`
  flex-direction: column;
  height: 100%;
  background: ${Colors.Background};
`

const GuestHeaderFlexContainer: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const GuestFooterFlexStaticContent = styled(FlexStaticContent)`
  background-color: ${Colors.GuestPrimary};
`

const GuestContentsAreaContainer: StyledDiv = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  background-color: ${Colors.Background};

  ${breakPoint.lessThan('sp')`
      display: contents;
  `}
`

const GuestContentsAreaComponent = styled(ContentsAreaComponent)`
  width: 100%;
  max-width: ${DispWidthSize.MaxWidth};
  margin-left: auto;
  margin-right: auto;
  box-shadow: 6px 0 5px -5px ${Colors.Shadow}, -6px 0 5px -5px ${Colors.Shadow};

  ${breakPoint.lessThan('sp')`
    min-height: 0;
    box-shadow: none;
  `}
`

const LOGOFF_PAGES: PathPattern[] = [
    {path: '/guest/error', end: true},
]

function isLogoffPage(location: Location): boolean {
    return LOGOFF_PAGES.some(logoffPage => matchPath(logoffPage, location.pathname))
}
